import { useTranslations } from "next-intl";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "@/hooks/useSearchParams";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { AuthLayout } from "./AuthLayout";
import { ActivateContent } from "./activate/ActivateContent";

export function ActivatePage() {
  const t = useTranslations("activate");
  const search = useSearchParams();
  const token = search.get("token");

  if (!token) return <Navigate to="/login" replace />;

  return (
    <AuthLayout>
      <SCard header={t("title")} outline="outline-quaternary" shadow="shadow-xl">
        <Spacing height="h-6" />
        <ActivateContent token={token} />
      </SCard>
    </AuthLayout>
  );
}
